import { ChatbotFaqList } from '../interfaces';
import { ApiChatbotAnswerInterface, ApiChatbotFaqInterface, ApiChatbotResponseInterface } from '../interfaces/api';

export const mapFaqListResponse = ({
    outputs,
    interactionId,
    sessionId
}: ApiChatbotResponseInterface): ChatbotFaqList => ({
    interactionId,
    sessionId,
    questions: getQuestions(outputs)
});

const getQuestions = (outputs) =>
    outputs[0].outputParts
        .find(({ type }: ApiChatbotAnswerInterface) => type === 'relatedFAQs')
        ?.faQs?.map(({ id, question }: ApiChatbotFaqInterface) => ({
            id,
            question
        })) || [];
